import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Plus, Radio, CalendarClock, PencilLine, Megaphone } from "lucide-react";
import { PermissaoEnum } from "@workflow/types";

import { Button } from "@/components/ui/button";
import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";
import { NumberKpiCard } from "@/components/shared/NumberKpiCard";
import { withPermissionPage } from "@/components/hocs/WithPermissionPage";

import { comunicadoSistemaQueries } from "@/services/api/queries/comunicado-sistema.queries";
import { ComunicadoSistemaListTable } from "./components/ComunicadoSistemaListTable";

const ComunicadosAdminPage = () => {
  const navigate = useNavigate();
  const { data: resumo, isLoading } = useQuery(comunicadoSistemaQueries.resumo());

  return (
    <div className="flex flex-col space-y-6 pb-10 duration-500 animate-in fade-in">
      <TopBarSection
        entity="Comunicado"
        title="Comunicados"
        subtitle="Avisos globais publicados para os usuários da plataforma."
        extraActions={[
          <Button
            key="create"
            size="sm"
            className="gap-2"
            onClick={() => navigate("/admin/comunicados/novo")}
          >
            <Plus className="h-4 w-4" />
            Novo comunicado
          </Button>,
        ]}
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <NumberKpiCard
          title="Vigentes"
          value={resumo?.vigentes ?? 0}
          icon={Radio}
          variant="emerald"
          loading={isLoading}
        />
        <NumberKpiCard
          title="Agendados"
          value={resumo?.agendados ?? 0}
          icon={CalendarClock}
          variant="blue"
          loading={isLoading}
        />
        <NumberKpiCard
          title="Rascunhos"
          value={resumo?.rascunhos ?? 0}
          icon={PencilLine}
          variant="amber"
          loading={isLoading}
        />
        <NumberKpiCard
          title="Total"
          value={resumo?.total ?? 0}
          icon={Megaphone}
          variant="purple"
          loading={isLoading}
        />
      </div>

      <div className="rounded-xl border border-border bg-card p-6 shadow-sm">
        <ComunicadoSistemaListTable storageKey="comunicados-admin-v2" />
      </div>
    </div>
  );
};

export default withPermissionPage(ComunicadosAdminPage, [PermissaoEnum.COMUNICADO_SISTEMA_MANAGE]);
